<div class="mt-5 pb-5">

   <div class="" *ngIf="showFilter">
      <h4 class="font-bold">Seleziona il tipo di storico da visualizzare</h4>
      <mat-radio-group class="example-radio-group" aria-label="Select an option" aria-labelledby="example-radio-group-label" [(ngModel)]="tipoTabella" (ngModelChange)="initGrid()">
         <mat-radio-button class="mx-2" [value]="'0'">Tutti</mat-radio-button>
         <mat-radio-button class="mx-2" [value]="'for'">Ordini fornitore</mat-radio-button>
         <mat-radio-button class="mx-2" [value]="'cli'">Ordini cliente</mat-radio-button>
         <mat-radio-button class="mx-2" [value]="'wb'">Ordini Web</mat-radio-button>
         <mat-radio-button class="mx-2" [value]="'for_r'">Reso Fornitore</mat-radio-button>
         <mat-radio-button class="mx-2" [value]="'cli_r'">Reso cliente</mat-radio-button>
         <mat-radio-button class="mx-2" [value]="'tras'">Trasferimento</mat-radio-button>
         <mat-radio-button class="mx-2" [value]="'amm'">Ammanco</mat-radio-button>
         <mat-radio-button class="mx-2" [value]="'esu'">Esubero</mat-radio-button>
      </mat-radio-group>
   </div>
   <div class="mt-3">
      <dx-data-grid #gridStoricoAss>
         <dxi-column dataField="created" dataType="datetime" caption="Data movimento"></dxi-column>
         <dxi-column *ngIf="!isVariante" dataField="prodotto_brand" caption="Brand"></dxi-column>
         <dxi-column *ngIf="!isVariante" dataField="prodotto_nome" caption="Nome Prodotto"></dxi-column>
         <dxi-column *ngIf="!isVariante" dataField="p_variant_colore" caption="Colore"></dxi-column>
         <dxi-column *ngIf="!isVariante" dataField="p_variant_codice" caption="Codice colore"></dxi-column>

         <dxi-column dataField="tipo" cellTemplate="tipoTemplate"></dxi-column>
         <div *dxTemplate="let cellInfo of 'tipoTemplate'">
            <div *ngFor="let tipo of Movimento.TipoMovimento">
               <span *ngIf="tipo.value == cellInfo.data.tipo">{{tipo.display}}</span>
            </div>
         </div>
         <dxi-column dataField="qta"></dxi-column>

         <dxi-column *ngIf="showColumnStampa" caption="Stampa" cellTemplate="stampaTemplate" width="90" alignment="center"></dxi-column>
         <div *dxTemplate="let cellInfo of 'stampaTemplate'">
            <button *ngIf="cellInfo.data.qta > 0 && cellInfo.data.tipo != TIPO_ORDINE.WEB" class="btn-tbl btn-primary ml-3"
                    (click)="clickOpenPrint(cellInfo.data)">
               <i class="fa-solid fa-print"></i>
            </button>
         </div>

         <dxi-column *ngIf="showColumnStampa" caption="DDT" cellTemplate="ddtTemplate" width="90" alignment="center"></dxi-column>
         <div *dxTemplate="let cellInfo of 'ddtTemplate'">
            <a *ngIf="cellInfo.data.tipo == 'for'" class="btn-tbl btn-primary ml-3"
               [routerLink]="['../ordini-fornitore/'+cellInfo.data.ordine_id]" target="_blank" [queryParams]="{tab_ddt:1}">

               <!--                     [routerLink]="cellInfo.data.tipo == 'tras' && cellInfo.data.qta < 0 ? ['../ordini-fornitore/'+cellInfo.data.first_order_rif] : ['../ordini-fornitore/'+cellInfo.data.ordine_id]" target="_blank" [queryParams]="{tab_ddt:1}"-->

               <i class="fa-solid fa-file-import"></i>
            </a>

         </div>
      </dx-data-grid>
   </div>
</div>

<app-print-etichette *ngIf="popupProfiloStampa"
                     [movimento]="movimento"
                     [popupProfiloStampa]="popupProfiloStampa"
                     [vendorSlug]="vendorSlug"
                     [pVenditaId]="pVenditaId"
                     [isSingle]="true"
                     [maxEtichette]="maxEtichette"
                     (onClose)="onClosePrintModal($event)"
                     (outputEvent)="stampaConvalide($event)">
</app-print-etichette>

